import TagManager from 'react-gtm-module-v2';

interface UserDoc {
  role: number | undefined | null;
  register_status?: number;
  company_id?: string;
}

interface CompanyDoc {
  plan?: string;
  status?: string | number;
}

/**
 * すでに取得済みのデータをGTMに流し込むだけの関数
 */
export const pushUserParams = (
  userDoc: UserDoc | undefined | null,
  companyDoc: CompanyDoc | undefined | null,
  authUid?: string,
): void => {
  const gtmData =
    !userDoc || !authUid
      ? {
          event: 'user_data_ready',
          user_id: undefined,
          user_role: null,
          company_id: undefined,
          company_plan: null,
          company_status: null,
        }
      : {
          event: 'user_data_ready',
          user_id: authUid,
          user_role: userDoc.role,
          register_status: userDoc.register_status,
          company_id: userDoc.company_id,
          company_plan: companyDoc?.plan,
          company_status: companyDoc?.status,
        };
  TagManager.dataLayer({
    dataLayer: gtmData,
  });
};
